import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Grid, List, ListItem } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
// import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";

import { Box, Typography } from "@mui/material";
import { unicodeToString, joinByKeys } from "../../../Js/Common";
import IconButton from "@mui/material/IconButton";
import AudioButton from "../../../Components/Media/AudioButton";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PauseIcon from "@mui/icons-material/Pause";
import SelectEvaluateComponent from "../../../Components/UI/SelectEvaluateComponent";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";

// var initLogObj = {
//   attempts: 1,
//   duration: 0,
//   assetType: {
//     group: "practice",
//     value: null,
//   },
//   userAnswer: [],
//   isEvaluated: "auto",
//   actualAnswer: [],
//   genericScore: 0,
// };

const NBEvaluate = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // Redux state
  const { paramsdata } = useSelector((state) => state.common);

  // State
  //   let [logObj, setLogObj] = useState(initLogObj);
  let [userAnswer, setUserAnswer] = useState([]);
  let [logData, setLogData] = useState(props.logData);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  useEffect(() => {
    console.log("props.content", props.content);
    console.log("logData", logData);

    if (props.content) {
      setUserAnswer(logData.outcome.userAnswer);
      setCurrentIndexPlay(
        new Array(props.content.epage.options.content.length).fill(false)
      );

      // dispatch(
      //     currentAssetSliceActions.setCurrentAttemptData(
      //         new Array(props.content.epage.options.content.length).fill([{ "text1": "" }])
      //     )
      // );

      //   setLogObj({
      //     ...logObj,
      //     assetType: {
      //       ...logObj.assetType,
      //       value: props.content.info.asset_type_alias,
      //     },
      //     actualAnswer: "",
      //     isEvaluated: "pending"
      //   });
    }
  }, [props.content]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const setPlayMode = (status, index, end) => {
    if (status == true && !end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <>
      {props.content &&
        props.content.epage.options.content.map((item, index) => {
          return (
            <Grid
              container
              sx={{
                alignItems: "center",
                border: 1,
                borderColor: "#EAECEE",
                borderRadius: 2,
                mb: 2,
              }}
              key={`${"nb_eval_" + index}`}
            >
              <Grid item xs={8}>
                <List>
                  <ListItem disablePadding sx={{}}>
                    {item && item.media && (
                      <OptionMedia
                        media={item.media}
                        isPlaying={currentIndexPlay[index]}
                        setPlayMode={(status, end) => {
                          setPlayMode(status, index, end);
                        }}
                        sx={{ margin: "4px" }}
                      ></OptionMedia>
                    )}
                    {item.text && (
                      <Typography
                        sx={{
                          pt: 1.5,
                          px: 2,
                          fontWeight: 500,
                          color: "primary.main",
                          fontSize: "1rem",
                          "@media (min-width:1636px)": { fontSize: "1.4rem" },
                        }}
                      >
                        {unicodeToString(item.text)}
                      </Typography>
                    )}
                  </ListItem>
                  <ListItem sx={{ backgroundColor: "#F5F5F5" }}>
                    {item.media && item.media.audio && (
                      <AudioButton
                        expertAudio={item.media.audio}
                        playStatus={(status, end) =>
                          setPlayMode(status, index, end)
                        }
                        containerStyle={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "10px 0",
                        }}
                      >
                        <IconButton
                          sx={{
                            color: "#DB8829",
                            backgroundColor: "#FFFFFF",
                            borderColor: "#EFEFEF",
                            backgroundColor: "#FFFFFF",
                            boxShadow: 2,
                            mx: 1,
                            padding: 0,
                            
                          }}
                        >
                          {currentIndexPlay[index] && (
                            <PauseIcon
                              sx={{
                                borderRadius: "50%",
                                padding: 1,
                                backgroundColor: "#DB8829",
                                color: "#FFFFFF",
                                "@media (min-width: 1636px)": {
                                  fontSize: "2.2rem",
                                },
                              }}
                            />
                          )}
                          {!currentIndexPlay[index] && (
                            <MusicNoteIcon
                              sx={{
                                borderRadius: "50%",
                                padding: 1,
                                "@media (min-width: 1636px)": {
                                  fontSize: "2.2rem",
                                },
                              }}
                            />
                          )}
                        </IconButton>
                      </AudioButton>
                    )}
                    {userAnswer && userAnswer.length > 0 && userAnswer[0] && (
                      <Box
                        sx={{
                          color: "primary.main",
                          fontWeight: "500",
                          fontSize: "0.9rem",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                          },
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: userAnswer[0]["ans"][index] && userAnswer[0]["ans"][index].length > 0 ? userAnswer[0]["ans"][index][0]["text1"] : "",
                          }}
                        ></div>
                      </Box>
                    )}
                  </ListItem>
                </List>
              </Grid>
              <Grid item xs={4} sx={{ px: 1 }}>
                <SelectEvaluateComponent
                  fetchBySelectedValue={(selectedEval) => {
                    props.scoreSelect(selectedEval, index);
                  }}
                  disableVal={false}
                />
              </Grid>
            </Grid>
          );
        })}
    </>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "78vh",
    overflow: "auto",
  },
});

export default NBEvaluate;
